import {
  CcfAvailableIcon,
  CcfBox,
  CcfButton,
  CcfTypography,
  CcfUnavailableIcon,
  CcfWorkingIcon,
  useTranslator,
} from '@nice-ccf/ui-controls';
import styles from './ccf-productivity.module.scss';
import { makeStyles } from '@mui/styles';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { agentStateHistory } from '../reporting-mock-data';
import { formatTimer } from '../../../util/common';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  tableCell: {
    padding: 8,
    border:'none',
  },
});

const stylesVar = {
  root: {
    height: 20,
  },
  colorPrimary: {
    backgroundColor: '#fff',
  },
  bar: {
    green: {
      background: '#39C44A',
    },
    yellow: {
      background: '#C78800',
    },

    red: {
      background: '#D0303B',
    },
  },
};

addLocale('es', {
  firstDayOfWeek: 1,
  dayNames: [
    'domingo',
    'lunes',
    'martes',
    'miércoles',
    'jueves',
    'viernes',
    'sábado',
  ],
  dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
  monthNames: [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ],
  monthNamesShort: [
    'ene',
    'feb',
    'mar',
    'abr',
    'may',
    'jun',
    'jul',
    'ago',
    'sep',
    'oct',
    'nov',
    'dic',
  ],
  today: 'Hoy',
  clear: 'Claro',
});

/**
 * used to show App enlighten static screen in app space
 * @param props - CcfAppEnlightenProps
 * @example ` <CcfAppEnlighten />`
 */
function createData(
  img: string,
  precentage: string,
  agentState: string,
  time: any
) {
  const hour = parseInt(time.split(':'));
  const width = hour === 0 ? 1 : hour * 8;
  return { img, precentage, agentState, time, width };
}

const agentHistoryFilter = agentStateHistory.filter(
  (item: any) => item.startDate === 'today'
);
const agentHistoryAvialableData = agentHistoryFilter.filter(
  (item: any) => item.agentStateName === 'available'
);
const agentHistoryWorkingData = agentHistoryFilter.filter(
  (item: any) => item.agentStateName === 'working'
);
const agentHistoryWorkingOutboundContactData = agentHistoryWorkingData.filter(
  (item: any) => item.outStateDescription === 'outboundContact'
);
const agentHistoryWorkingInboundContactData = agentHistoryWorkingData.filter(
  (item: any) => item.outStateDescription === 'inboundContact'
);
const agentHistoryWorkingInboundConsultData = agentHistoryWorkingData.filter(
  (item: any) => item.outStateDescription === 'inboundConsult'
);
const agentHistoryWorkingOutboundConsultData = agentHistoryWorkingData.filter(
  (item: any) => item.outStateDescription === 'outboundConsult'
);
const agentHistoryUnavialableData = agentHistoryFilter.filter(
  (item: any) => item.agentStateName === 'unavailable'
);
const agentHistoryUnavialableBreakData = agentHistoryUnavialableData.filter(
  (item: any) => item.outStateDescription === 'Break'
);
const agentHistoryUnavialableLunchData = agentHistoryUnavialableData.filter(
  (item: any) => item.outStateDescription === 'Lunch'
);
const agentHistoryUnavialableCoachingData = agentHistoryUnavialableData.filter(
  (item: any) => item.outStateDescription === 'Coaching'
);
const rowArr: any = [];
const avialableDuration = agentHistoryAvialableData.reduce(
  (totalduration: number, item: any) => (totalduration += item.duration),
  0
);
const avialablePercentage = (avialableDuration / 460) * 100;
rowArr.push(
  createData(
    '1',
    Math.round(avialablePercentage) + '%',
    'available',
    formatTimer(avialableDuration)
  )
);
const WorkingDuration = agentHistoryWorkingData.reduce(
  (totalduration: number, item: any) => (totalduration += item.duration),
  0
);
const workingPercentage = (WorkingDuration / 460) * 100;
rowArr.push(
  createData(
    '2',
    Math.round(workingPercentage) + '%',
    'working',
    formatTimer(WorkingDuration)
  )
);
const WorkingInboundContactDuration =
  agentHistoryWorkingInboundContactData.reduce(
    (totalduration: number, item: any) => (totalduration += item.duration),
    0
  );
rowArr.push(
  createData(
    '',
    '',
    'inboundContact',
    formatTimer(WorkingInboundContactDuration)
  )
);
const WorkingOutboundContactDuration =
  agentHistoryWorkingOutboundContactData.reduce(
    (totalduration: number, item: any) => (totalduration += item.duration),
    0
  );

rowArr.push(
  createData(
    '',
    '',
    'outboundContact',
    formatTimer(WorkingOutboundContactDuration)
  )
);

rowArr.push(createData('', '', 'dailerPending', '01:14'));
const WorkingInboundConsultDuration =
  agentHistoryWorkingInboundConsultData.reduce(
    (totalduration: number, item: any) => (totalduration += item.duration),
    0
  );

rowArr.push(
  createData(
    '',
    '',
    'inboundConsult',
    formatTimer(WorkingInboundConsultDuration)
  )
);
const WorkingOutboundConsultDuration =
  agentHistoryWorkingOutboundConsultData.reduce(
    (totalduration: number, item: any) => (totalduration += item.duration),
    0
  );
rowArr.push(
  createData(
    '',
    '',
    'outboundConsult',
    formatTimer(WorkingOutboundConsultDuration)
  )
);

const UnavailableDuration = agentHistoryUnavialableData.reduce(
  (totalduration: number, item: any) => (totalduration += item.duration),
  0
);
const UnavailablePercentage = (UnavailableDuration / 460) * 100;
rowArr.push(
  createData(
    '3',
    Math.round(UnavailablePercentage) + '%',
    'unavailable',
    formatTimer(UnavailableDuration)
  )
);

const UnavailableBreakDuration = agentHistoryUnavialableBreakData.reduce(
  (totalduration: number, item: any) => (totalduration += item.duration),
  0
);
const UnavailableLunchDuration = agentHistoryUnavialableLunchData.reduce(
  (totalduration: number, item: any) => (totalduration += item.duration),
  0
);
rowArr.push(
  createData(
    '',
    '',
    'afterCallWork',
    formatTimer(UnavailableBreakDuration + UnavailableLunchDuration)
  )
);
const UnavailableCoachingDuration = agentHistoryUnavialableCoachingData.reduce(
  (totalduration: number, item: any) => (totalduration += item.duration),
  0
);

rowArr.push(
  createData('', '', 'Coaching', formatTimer(UnavailableCoachingDuration))
);

/* eslint-disable-next-line */
export interface CcfProductivityProps {}
/**
 * used to show App enlighten static screen in app space
 * @param props - CcfAppEnlightenProps
 * @example ` <CcfAppEnlighten />`
 */
export function CcfProductivity(props: CcfProductivityProps) {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [clickedButton, setClickedButton] = useState('Today');
  const [rows, setRows] = useState(rowArr);
  const [dates2, setDates2] = useState<Date | Date[] | undefined>(undefined);
  const [isVisible, setisVisible] = useState(true);
  const [workingPercentageForHeader, setworkingPercentageForHeader] = useState(
    Math.round(workingPercentage)
  );
  const [translate] = useTranslator();
  const classes = useStyles();
  const today = new Date();
  const month = today.getMonth();
  const calendeRef = useRef(null);
  const prevMonth = month === 0 ? 11 : month - 1;
  const minDate = new Date();
  minDate.setMonth(prevMonth);

  useEffect(() => {
    if (Array.isArray(dates2) && dates2[1] !== null) {
      const time_difference = dates2[1].getTime() - dates2[0].getTime();
      const days_difference = time_difference / (1000 * 60 * 60 * 24);
      if (days_difference >= 0 && days_difference < 11) {
        handleFilterButtonclick('Custom', 10);
      } else if (days_difference >= 11 && days_difference < 21) {
        handleFilterButtonclick('Custom', 20);
      } else {
        handleFilterButtonclick('Custom', 30);
      }
    }
  }, [dates2]);

  /**
   * used to show App enlighten static screen in app space
   * @param props - CcfAppEnlightenProps
   * @example ` <CcfAppEnlighten />`
   */
  const handleFilterButtonclick = (btnLabel: string, daysdiff: number) => {
    if (btnLabel === 'custom' || clickedButton !== btnLabel) {
      let dividedBy = 0;
      setClickedButton(btnLabel);
      switch (btnLabel) {
        case 'today':
          dividedBy = 480;
          break;
        case 'yesterday':
          dividedBy = 750;
          break;
        case 'last7days':
          dividedBy = 900;
          break;
      }
      let agentHistoryFilter = agentStateHistory.filter(
        (item: any) => item.startDate === btnLabel
      );
      if (daysdiff > 0) {
        agentHistoryFilter = agentHistoryFilter.slice(0, daysdiff);
        if (daysdiff === 10) {
          dividedBy = 250;
        } else if (daysdiff === 20) {
          dividedBy = 620;
        } else {
          dividedBy = 1000;
        }
      }
      const agentHistoryAvialableData = agentHistoryFilter.filter(
        (item: any) => item.agentStateName === 'available'
      );
      const agentHistoryWorkingData = agentHistoryFilter.filter(
        (item: any) => item.agentStateName === 'working'
      );
      const agentHistoryWorkingOutboundContactData =
        agentHistoryWorkingData.filter(
          (item: any) => item.outStateDescription === 'outboundContact'
        );
      const agentHistoryWorkingInboundContactData =
        agentHistoryWorkingData.filter(
          (item: any) => item.outStateDescription === 'inboundContact'
        );
      const agentHistoryWorkingInboundConsultData =
        agentHistoryWorkingData.filter(
          (item: any) => item.outStateDescription === 'inboundConsult'
        );
      const agentHistoryWorkingOutboundConsultData =
        agentHistoryWorkingData.filter(
          (item: any) => item.outStateDescription === 'outboundConsult'
        );
      const agentHistoryUnavialableData = agentHistoryFilter.filter(
        (item: any) => item.agentStateName === 'unavailable'
      );
      const agentHistoryUnavialableBreakData =
        agentHistoryUnavialableData.filter(
          (item: any) => item.outStateDescription === 'Break'
        );
      const agentHistoryUnavialableLunchData =
        agentHistoryUnavialableData.filter(
          (item: any) => item.outStateDescription === 'Lunch'
        );
      const agentHistoryUnavialableCoachingData =
        agentHistoryUnavialableData.filter(
          (item: any) => item.outStateDescription === 'Coaching'
        );
      const rowArr = [];
      const avialableDuration = agentHistoryAvialableData.reduce(
        (totalduration: number, item: any) => (totalduration += item.duration),
        0
      );
      const avialablePercentage = (avialableDuration / dividedBy) * 100;
      rowArr.push(
        createData(
          '1',
          Math.round(avialablePercentage) + '%',
          'available',
          formatTimer(avialableDuration)
        )
      );
      const WorkingDuration = agentHistoryWorkingData.reduce(
        (totalduration: number, item: any) => (totalduration += item.duration),
        0
      );
      const workingPercentage = (WorkingDuration / dividedBy) * 100;
      rowArr.push(
        createData(
          '2',
          Math.round(workingPercentage) + '%',
          'working',
          formatTimer(WorkingDuration)
        )
      );
      setworkingPercentageForHeader(Math.round(workingPercentage));

      const WorkingInboundContactDuration =
        agentHistoryWorkingInboundContactData.reduce(
          (totalduration: number, item: any) =>
            (totalduration += item.duration),
          0
        );
      rowArr.push(
        createData(
          '',
          '',
          'inboundContact',
          formatTimer(WorkingInboundContactDuration)
        )
      );
      const WorkingOutboundContactDuration =
        agentHistoryWorkingOutboundContactData.reduce(
          (totalduration: number, item: any) =>
            (totalduration += item.duration),
          0
        );

      rowArr.push(
        createData(
          '',
          '',
          'outboundContact',
          formatTimer(WorkingOutboundContactDuration)
        )
      );

      rowArr.push(createData('', '', 'dailerPending', '01:14'));
      const WorkingInboundConsultDuration =
        agentHistoryWorkingInboundConsultData.reduce(
          (totalduration: number, item: any) =>
            (totalduration += item.duration),
          0
        );

      rowArr.push(
        createData(
          '',
          '',
          'inboundConsult',
          formatTimer(WorkingInboundConsultDuration)
        )
      );
      const WorkingOutboundConsultDuration =
        agentHistoryWorkingOutboundConsultData.reduce(
          (totalduration: number, item: any) =>
            (totalduration += item.duration),
          0
        );
      rowArr.push(
        createData(
          '',
          '',
          'outboundConsult',
          formatTimer(WorkingOutboundConsultDuration)
        )
      );

      const UnavailableDuration = agentHistoryUnavialableData.reduce(
        (totalduration: number, item: any) => (totalduration += item.duration),
        0
      );
      const UnavailablePercentage = (UnavailableDuration / dividedBy) * 100;
      rowArr.push(
        createData(
          '3',
          Math.round(UnavailablePercentage) + '%',
          'unavailable',
          formatTimer(UnavailableDuration)
        )
      );

      const UnavailableBreakDuration = agentHistoryUnavialableBreakData.reduce(
        (totalduration: number, item: any) => (totalduration += item.duration),
        0
      );
      const UnavailableLunchDuration = agentHistoryUnavialableLunchData.reduce(
        (totalduration: number, item: any) => (totalduration += item.duration),
        0
      );
      rowArr.push(
        createData(
          '',
          '',
          'afterCallWork',
          formatTimer(UnavailableBreakDuration + UnavailableLunchDuration)
        )
      );
      const UnavailableCoachingDuration =
        agentHistoryUnavialableCoachingData.reduce(
          (totalduration: number, item: any) =>
            (totalduration += item.duration),
          0
        );

      rowArr.push(
        createData('', '', 'Coaching', formatTimer(UnavailableCoachingDuration))
      );
      console.log(avialableDuration);
      console.log(WorkingDuration);
      console.log(UnavailableDuration);
      setRows(rowArr);
      if (btnLabel !== 'custom') {
        setShowDatePicker(false);
      }
    } else {
      setClickedButton('');
    }
    //setShowDatePicker(false);
  };

  /**
   * used to show App enlighten static screen in app space
   * @param props - CcfAppEnlightenProps
   * @example ` <CcfAppEnlighten />`
   */
  const handleCustomButtonclick = (e: any) => {
    if (clickedButton !== e.target.textContent) {
      setClickedButton(e.target.textContent);
    } else {
      setClickedButton('');
    }
    setDates2(undefined);
    setShowDatePicker(!showDatePicker);
  };
  /**
   * used to show App enlighten static screen in app space
   * @param props - CcfAppEnlightenProps
   * @example ` <CcfAppEnlighten />`
   */
  function renderIcon(iconCode: string) {
    switch (iconCode) {
      case '1':
        return <CcfAvailableIcon />;
      case '2':
        return <CcfWorkingIcon />;
      case '3':
        return <CcfUnavailableIcon />;
      default:
        return '';
    }
  }

  return (
    <CcfBox className={styles.productivityContainer}>
      <section
        className={
          showDatePicker
            ? styles.productivityHeader
            : styles.productivityHeaderWithMargin
        }
      >
        <CcfTypography className={styles.tabValue}>
          {translate('productivity')} ({workingPercentageForHeader + '%'})
        </CcfTypography>
        <div>
          <CcfButton
            className={
              clickedButton !== 'today' ? styles.activeBtn : styles.defaultBtn
            }
            variant="outlined"
            value="today"
            onClick={() => handleFilterButtonclick('today', 0)}
          >
            {translate('today')}
          </CcfButton>
          <CcfButton
            className={
              clickedButton !== 'Yesterday'
                ? styles.activeBtn
                : styles.defaultBtn
            }
            variant="outlined"
            value="yesterday"
            onClick={() => handleFilterButtonclick('yesterday', 0)}
          >
            {translate('yesterday')}
          </CcfButton>
          <CcfButton
            className={
              clickedButton !== 'last7days'
                ? styles.activeBtn
                : styles.defaultBtn
            }
            variant="outlined"
            value="last7days"
            onClick={() => handleFilterButtonclick('last7days', 0)}
          >
            {translate('last7days')}
          </CcfButton>
          <CcfButton
            className={
              clickedButton !== 'custom' ? styles.activeBtn : styles.defaultBtn
            }
            variant="outlined"
            value="custom"
            onClick={(e) => handleCustomButtonclick(e)}
          >
            {translate('custom')}
          </CcfButton>
        </div>
      </section>
      {showDatePicker && (
        <section className={styles.customFilterContainer}>
          <Calendar
            ref={calendeRef}
            visible={isVisible}
            hideOnDateTimeSelect={true}
            showButtonBar
            placeholder={translate("SelectDateRange")}
            id="range"
            showIcon
            minDate={minDate}
            maxDate={today}
            value={dates2}
            onChange={(e:any) => setDates2(e.value)}
            selectionMode="range"
            readOnlyInput
          />
        </section>
      )}
      <TableContainer >
        <Table className={classes.table} aria-label="simple table">
          <TableHead className={styles.tableHeader}>
            <TableRow
              style={{ background: '#ECF3F8', borderColor: 'transparent' }}
            >
              <TableCell
                style={{ width: '10%' }}
                align="left"
                className={classes.tableCell}
              ></TableCell>
              <TableCell style={{ width: '30%' }} className={classes.tableCell}>
                {translate('agentState')}
              </TableCell>
              <TableCell align="left" className={classes.tableCell}>
                {translate('time')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={styles.tableBody}>
            {rows.map((row: any, index: number) => (
              <TableRow key={row.agentState}
                >
                <TableCell
                  style={{ width: '10%' }}
                  component="th"
                  scope="row"
                  className={classes.tableCell}
                >
                  {renderIcon(row?.img)}
                </TableCell>
                {index === 0 || index === 1 || index === 7 ? (
                  <TableCell
                    style={{ width: '30%', fontWeight: 'bolder' }}
                    component="th"
                    scope="row"
                    className={classes.tableCell}
                  >
                    {translate(row?.agentState)} {'(' + row?.precentage + ')'}
                  </TableCell>
                ) : (
                  <TableCell
                    style={{ width: '30%' }}
                    component="th"
                    scope="row"
                    className={classes.tableCell}
                  >
                    {translate(row?.agentState)}
                  </TableCell>
                )}
                <TableCell
                  align="left"
                  style={{ display: 'flex' }}
                  className={classes.tableCell}
                >
                  <div
                    style={{
                      ...stylesVar.root,
                      ...stylesVar.colorPrimary,
                      ...(index === 0
                        ? stylesVar.bar.green
                        : index >= 1 && index <= 6
                        ? stylesVar.bar.yellow
                        : stylesVar.bar.red),
                      width: row?.width + '%',
                    }}
                  ></div>
                  {index === 0 || index === 1 || index === 7 ? (
                    <CcfTypography
                      style={{ marginLeft: '20px', fontWeight: 'bolder' }}
                    >
                      {row?.time}{' '}
                    </CcfTypography>
                  ) : (
                    <CcfTypography style={{ marginLeft: '20px' }}>
                      {row?.time}{' '}
                    </CcfTypography>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </CcfBox>
  );
}

export default CcfProductivity;
